<script setup>
import { useAppStore } from '~//store/main'

const props = defineProps({
  layer: { type: Number, default: 0 },
  id: { type: String, default: '' },
})

const store = useAppStore()
const {
  getRootMenu,
  getStudiumNav,
  getAcademyNav,
  getProgramNav,
  getStudiumNavByID,
  getAcademyNavByID,
  getProgramNavByID,
} = storeToRefs(store)
const { setLayer, setLayerId, setShowMenuLayer, setRootMenu } = store

const firstLink = ref({})
const otherLinks = ref([])
const otherLinks2 = ref([])
const show = ref(false)
const show2 = ref(false)

const updateLayer = () => {
  switch (props.layer) {
    case 0:
      show.value = false

      firstLink.value = getStudiumNav.value[0] || {}
      otherLinks.value = getStudiumNav.value.slice(1)
      break
    case 1:
      show.value = false

      firstLink.value = getAcademyNav.value[0] || {}
      otherLinks.value = getAcademyNav.value.slice(1)
      break
    case 2:
      show.value = false

      firstLink.value = getProgramNav.value[0] || {}
      otherLinks.value = getProgramNav.value.slice(1)
      break
    case 3:
      firstLink.value = {}

      if (getRootMenu.value === 'studium') {
        otherLinks2.value = getStudiumNavByID.value(props.id) || []
      } else if (getRootMenu.value === 'akademie') {
        otherLinks2.value = getAcademyNavByID.value(props.id) || []
      } else if (getRootMenu.value === 'program') {
        otherLinks2.value = getProgramNavByID.value(props.id) || []
      }
      break
  }
  setTimeout(() => (show.value = true), 100)
}

const updateLayer2 = () => {
  show2.value = false
  updateLayer()
  setTimeout(() => (show2.value = true), 100)
}

const closeMenu = () => {
  setLayer(0)
  setLayerId('')
  setShowMenuLayer(false)
  setRootMenu('')
}

watch(() => props.layer, updateLayer)
watch(() => props.id, updateLayer2)

onMounted(() => {
  updateLayer()
  updateLayer2()
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>

<template>
  <div v-if="otherLinks.length" class="sliderWrapper" @click="closeMenu">
    <!-- <Grad class="grad grad--top" />
    <GradBottom class="grad grad--bottom" /> -->

    <div class="closeRow slider slider--close">
      <Close class="links" :back="false" />
    </div>

    <Transition name="slider">
      <div v-if="show2" class="slider">
        <div v-if="layer === 3 && otherLinks2?.childItems" class="links">
          <RowLink
            v-for="item in otherLinks2.childItems.nodes"
            :id="item.id"
            :key="item.id"
            :label="item.label"
            :slug="
              item.connectedNode ? item.connectedNode.node.slug : item.path
            "
            :content-type="
              item.connectedNode
                ? item.connectedNode.node.contentType?.node.name || ''
                : ''
            "
            :root="getRootMenu"
            :navigation="true"
          />
        </div>
      </div>
    </Transition>

    <Transition name="slider">
      <div v-if="show" class="slider">
        <div class="links">
          <RowLink
            v-for="item in otherLinks"
            :id="item.id"
            :key="item.id"
            :label="item.label"
            :slug="
              item.connectedNode ? item.connectedNode.node.slug : item.path
            "
            :content-type="
              item.connectedNode?.node.contentType?.node.name ||
              item.connectedNode?.node.taxonomy?.node.name ||
              ''
            "
            :root="getRootMenu"
            :navigation="true"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.sliderWrapper {
  position: relative;

  display: flex;
  flex-flow: row-reverse nowrap;
  justify-content: space-between;
  gap: 40px;
}

.grad {
  position: fixed;
  width: 100%;
  z-index: 2;
  left: -20%;
  pointer-events: none;

  stop {
    transition: 0.3s;
    stop-color: $color-1;
  }

  rect {
    display: block;
    width: 100vw;
  }

  &--top {
    position: absolute;
    top: 0px;
    height: 100px;
  }
  &--bottom {
    left: 0;
    bottom: 0px;
    height: 90px;
    rotate: 180deg;
  }
}

h1 {
  padding-top: 25.5px;
}

.closeRow {
  margin-top: -41px;
}

.links {
  padding-top: 40px;
  padding-bottom: 40px;
  margin-bottom: 90px;
}

.slider {
  padding: 1px 1px 100px;
  width: 30%;
  height: calc(100vh);

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.slider-enter-active,
.slider-leave-active {
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;
}

.slider-enter-from,
.slider-leave-to {
  opacity: 0;
  transform: translate3d(-1rem, 0, 0);
}
</style>
